import { isNil } from 'lodash-es';
import React from 'react';

import { useUserInfo } from 'queries/user-action/use-user-info';

import SignInButton from './components/SignInButton';
import UserWidget from './components/UserWidget';
import useStyles from './styles';

interface Props {
    hidden?: boolean;
    className?: string;
}

const AuthWidget: React.FC<Props> = ({ hidden, className }) => {
    const { classes, cx } = useStyles();
    const userInfoQuery = useUserInfo();

    if (userInfoQuery.isLoading) {
        return null;
    }

    if (isNil(userInfoQuery.data)) {
        return <SignInButton className={cx({ [classes.hidden]: hidden }, className)} />;
    }

    return <UserWidget user={userInfoQuery.data} className={cx({ [classes.hidden]: hidden }, className)} />;
};

export default AuthWidget;
